import React from "react";

type IconProps = React.HTMLAttributes<SVGElement>;

export const Icons = {
  ChevronDownIcon: (props: IconProps) => (
    <svg
      viewBox="0 0 18 18"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <path d="M2.90172 4.86762L1.57422 6.20262L8.99922 13.6201L16.4242 6.19512L15.0967 4.86762L8.99922 10.9651L2.90172 4.86762Z" />
    </svg>
  ),
  ChevronRightIcon: (props: IconProps) => (
    <svg
      viewBox="0 0 18 18"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <path d="M4.86762 15.0983L6.20262 16.4258L13.6201 9.00078L6.19512 1.57578L4.86762 2.90328L10.9651 9.00078L4.86762 15.0983Z" />
    </svg>
  ),
  ChevronLeftIcon: (props: IconProps) => (
    <svg
      viewBox="0 0 18 18"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <path d="M13.1324 2.90172L11.7974 1.57422L4.37988 8.99922L11.8049 16.4242L13.1324 15.0967L7.03488 8.99922L13.1324 2.90172Z" />
    </svg>
  ),
  ChevronsUpDownIcon: (props: IconProps) => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <path d="m7 15 5 5 5-5" />
      <path d="m7 9 5-5 5 5" />
    </svg>
  ),
  CheckIcon: (props: IconProps) => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <path d="M20 6 9 17l-5-5" />
    </svg>
  ),
  ExternalLinkIcon: (props: IconProps) => (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <path
        d="M13.5 8.75V13.25C13.5 13.6478 13.342 14.0294 13.0607 14.3107C12.7794 14.592 12.3978 14.75 12 14.75H3.75C3.35218 14.75 2.97064 14.592 2.68934 14.3107C2.40804 14.0294 2.25 13.6478 2.25 13.25V5C2.25 4.60218 2.40804 4.22064 2.68934 3.93934C2.97064 3.65804 3.35218 3.5 3.75 3.5H8.25M11.25 1.25H15.75M15.75 1.25V5.75M15.75 1.25L7.5 9.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  SearchIcon: (props: IconProps) => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <path d="m21 21-4.34-4.34" />
      <circle cx="11" cy="11" r="8" />
    </svg>
  ),
  CloseIcon: (props: IconProps) => (
    <svg
      viewBox="0 0 18 18"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <path d="M16.7525 2.90172L15.4175 1.57422L8 8.99922L15.425 16.4242L16.7525 15.0967L10.655 8.99922L16.7525 2.90172Z" />
      <path d="M1.9975 15.0963L3.3325 16.4238L10.75 8.99883L3.325 1.57383L1.9975 2.90133L8.095 8.99883L1.9975 15.0963Z" />
    </svg>
  ),
  ReloadIcon: (props: IconProps) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <path d="M19.933 13.041a8 8 0 1 1 -9.925 -8.788c3.899 -1 7.935 1.007 9.425 4.747" />
      <path d="M20 4v5h-5" />
    </svg>
  ),
  PlusIcon: (props: IconProps) => (
    <svg
      viewBox="0 0 12 12"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <path d="M6 1V11M1 6H11" />
    </svg>
  ),
  GlobeIcon: (props: IconProps) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.2"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <circle cx="8" cy="8" r="6.5" />
      <ellipse cx="8" cy="8" rx="3" ry="6.5" />
      <line x1="1.5" y1="8" x2="14.5" y2="8" />
    </svg>
  ),
  ChevronDownLineIcon: (props: IconProps) => (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <path d="M1 1L5 5L9 1" />
    </svg>
  ),
};
